export function clamp(
  number: number,
  bounds: Readonly<{ min?: number; max?: number }>
): number {
  const { min, max } = bounds
  if (min !== undefined && number < min) return min
  if (max !== undefined && number > max) return max
  return number
}

let _uniqueNumber = 0
export function uniqueNumber() {
  return _uniqueNumber++
}
